import { render } from "./BlViewEmail.vue?vue&type=template&id=20e1451b"
import script from "./BlViewEmail.vue?vue&type=script&lang=js"
export * from "./BlViewEmail.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/6f278242-b890-433a-91e8-ee1cfc12c380/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__